import axios from "axios";

// Prefer the current page origin so custom-domain remaps (e.g. noexcuse.life) work
// without rebuilding the frontend. Falls back to REACT_APP_BACKEND_URL for non-browser
// contexts (tests, SSR).
const BACKEND_URL =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API,
    withCredentials: true,
});

client.interceptors.request.use((config) => {
    const token = localStorage.getItem("noexcuse_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default client;

export function videoUrl(submissionId) {
    const token = localStorage.getItem("noexcuse_token") || "";
    return `${API}/submissions/${submissionId}/video?auth=${encodeURIComponent(token)}`;
}

export function formatErr(err) {
    const detail = err?.response?.data?.detail;
    if (!detail) return err?.message || "Something went wrong";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail.map((e) => e?.msg || JSON.stringify(e)).join(", ");
    return String(detail);
}
